export enum AccessScope {
  MAIN_DOCUMENT = 'ACCESS_SCOPE:MAIN_DOCUMENT',
  WITH_ACCOMPANYING_DOCUMENTS = 'ACCESS_SCOPE:WITH_ACCOMPANYING_DOCUMENTS',
}
